import { UnityHubLayout } from 'App/components/UnityHub'
import { CommunityInfo } from 'App/components/Communities'

export const PublicCommunityInfo = () => (
  <UnityHubLayout>
    <CommunityInfo />
  </UnityHubLayout>
)
